/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import { useEffect, useState } from "react";
import React from "react";
import Select from "react-select";
import { Link, useParams, useNavigate } from "react-router-dom";
import "./ChapterList.css"


const ChapterList = () => {
  const [chapters, setChapters] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();
  const [userPermissions, setUserPermissions] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const loggedInUser = "S3Fwc3A1R2tqeHBPNThNWWp5cy9hdz09";
  const token = "kasejfksjdhfywterjwefbdskgfhsdfjh";

  const subjectOptions = subjects.map((subject) => ({
    value: subject.id,
    label: `${subject.subjectName} (${subject.subjectCount})`,
  }));


  async function fetchSubjects() {
    try {

      const role = localStorage.getItem("role");


      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getSubjectOnChange");
      fd.append("role", role);

      const subjectResponse = await axios.post("https://qp.sarvajna.co.in/api/controller/onchange/onchangeCurl", fd);
      const fetchedSubjects = Array.isArray(subjectResponse.data)
        ? subjectResponse.data
        : [];
      setSubjects(fetchedSubjects);

      // ✅ Set selected subjects from localStorage after subjects are fetched
      const storedSubjectIds =
        JSON.parse(localStorage.getItem("selectedSubjects")) || [];
      setSelectedSubjects(storedSubjectIds);

      // ⏳ Auto-fetch chapters after restoring selected subjects
      if (storedSubjectIds.length > 0) {
        setTimeout(fetchChapters, 0); // Small delay to ensure state is updated
      }
    } catch (error) {
      console.error("Error fetching subjects:", error);
      setSubjects([]);
    }
  }


  const customSelectStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "38px", // Match button height
      height: "38px",
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "38px",
      padding: "0 8px",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "38px",
    }),
  };

  async function fetchChapters() {
    setIsLoading(true);
    try {

      const fd = new FormData();
      fd.append("loggedInUser", loggedInUser);
      fd.append("token", token);
      fd.append("programType", "getChapterOnChangeMultiple");
      fd.append("paperId", id);

      selectedSubjects.forEach((subjectId) => {
        fd.append("subjectId[]", subjectId);
      });

      const response = await axios.post("https://qp.sarvajna.co.in/api/controller/onchange/onchangeCurl", fd);

      if (response.data && Array.isArray(response.data.data)) {
        // ✅ Get stored selected chapters
        const storedChapterIds =
          JSON.parse(localStorage.getItem("selectedChapters")) || [];

        const updatedChapters = response.data.data.map((chapter) => ({
          ...chapter,
          selected: storedChapterIds.includes(String(chapter.id)), // ✅ Check against stored list
        }));

        setChapters(updatedChapters);
      } else {
        setChapters([]);
      }
    } catch (error) {
      console.error("Error fetching chapters:", error);
      setChapters([]);
    } finally {
      setIsLoading(false);
    }
  }

  const handleSelectAllChange = (e) => {
    const isChecked = e.target.checked;
    const updatedChapters = chapters.map((chapter) => ({
      ...chapter,
      selected: isChecked,
    }));
    setChapters(updatedChapters);
  };


  const filteredChapters = chapters.filter(
    (chapter) =>
      chapter.chapterName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      String(chapter.id).includes(searchTerm)
  );

  useEffect(() => {
    fetchSubjects();
  }, []);

  const handleChapterChange = (chapterIndex) => {
    const updatedChapters = [...chapters];
    updatedChapters[chapterIndex].selected =
      !updatedChapters[chapterIndex].selected;
    setChapters(updatedChapters);
  };

  async function handleSubmit() {

    const selectedChapterIds = chapters
      .filter((chapter) => chapter.selected)
      .map((chapter) => chapter.id);

    // ✅ Store selected chapters and subjects in localStorage
    localStorage.setItem(
      "selectedChapters",
      JSON.stringify(selectedChapterIds)
    );
    localStorage.setItem("selectedSubjects", JSON.stringify(selectedSubjects));

    const fd = new FormData();
    fd.append("paperId", id);
    fd.append("chapterId", selectedChapterIds.join(","));
    fd.append("programType", "addChapterToPaper");
    fd.append("loggedInUser", loggedInUser);
    fd.append("token", token);

    try {
      const response = await axios.post("https://qp.sarvajna.co.in/api/controller/picQuestion/picQuestionCurl", fd);
      console.log("Chapters added successfully");
    } catch (error) {
      console.error("Error submitting chapters:", error);
      alert("Failed to submit chapters");
    }
  }

  const allSelected =
    filteredChapters.length > 0 &&
    filteredChapters.every((chapter) => chapter.selected);


  return (
    <div className="container " style={{ marginTop: "5.5rem", marginBottom: "6.5rem" }}>
      {userPermissions.is_view === "0" ? (
        <div className="alert alert-danger text-center">Permission Denied</div>
      ) : (
        <>


          <form
            className="mb-4"
            onSubmit={(e) => {
              e.preventDefault();
              fetchChapters();
            }}
          >
            <h5 className="mb-2">Select Subjects</h5>

            <div className="row align-items-center">
              <div className="col-md-9">
                <Select
                  isMulti
                  options={subjectOptions}
                  value={subjectOptions.filter((option) =>
                    selectedSubjects.includes(option.value)
                  )}
                  onChange={(selectedOptions) => {
                    const selectedIds = selectedOptions.map(
                      (option) => option.value
                    );
                    setSelectedSubjects(selectedIds);
                  }}
                  menuPortalTarget={document.body}
                  styles={{
                    ...customSelectStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  }}
                />
              </div>
              <div className="col-md-3 mt-3 mt-md-0">
                <button className="col-12 btn btn-primary" style={{ height: "40px", display: "flex", alignItems: "center", justifyContent: "center" }} type="submit">
                  Fetch Chapters
                </button>
              </div>
            </div>
          </form>

          {isLoading ? (
            <p></p>
          ) : chapters.length > 0 ? (
            <div
              className="card"
              style={{ marginBottom: "20px", marginTop: "20px" }}
            >
              <div
                className="card-header text-white"
                style={{ display: "flex", justifyContent: "space-between", backgroundColor: "white" }}
              >

                <input
                  name="search"
                  className="form-control"

                  placeholder="Search by Chapter Name"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="card-body">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Chapter Name</th>
                      <th>
                        <div className="d-flex align-items-center gap-1">
                          <input
                            type="checkbox"
                            checked={allSelected}
                            onChange={handleSelectAllChange}
                          />
                          <label className="mb-0">Select</label>
                        </div>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredChapters.map((chapter, i) => (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{chapter.chapterName}</td>
                        <td>
                          <input
                            type="checkbox"
                            checked={chapter.selected || false}
                            onChange={() =>
                              handleChapterChange(chapters.indexOf(chapter))
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div
                className="d-flex justify-content-between align-items-center mt-4 p-4"
                style={{ gap: "1rem", borderTop: "1px solid #eee" }}
              >
                <button
                  className="no-hover btn-skip"
                  onClick={() => navigate(`/pick-questions/${id}`)}
                >
                  Skip
                </button>

                <button
                  className="no-hover btn-submit"
                  onClick={async () => {
                    await handleSubmit();
                    navigate(`/pick-questions/${id}`);
                  }}
                >
                  Submit
                </button>
              </div>

            </div>
          ) : (
            <p></p>
          )}
        </>
      )}
    </div>
  );
};

export default ChapterList;
